import React, { useContext } from 'react';
import { TreeContext } from '../../context/TreeContext';
import '../../styles/components/ControlColumn.css';

// Helper components
const ColorControl = ({ label, field, value, setActiveColorField, activeColorField }) => (
  <div className="color-control">
    <label>{label}</label>
    <div 
      className={`color-swatch ${activeColorField === field ? 'active' : ''}`}
      style={{ backgroundColor: value }}
      onClick={() => setActiveColorField(field)}
    />
  </div>
);

const ColorPicker = ({ activeField, handleColorChange, onClose }) => {
  if (!activeField) return null;
  
  // Color presets for trees
  const treePresets = [
    // Trunk colors
    '#6B4423', '#8B4513', '#A0522D', '#954535', '#5E2612',
    '#4A3728', '#6F4E37', '#702E24', '#7D482D', '#7E3517',
    // Foliage colors - green variations
    '#2D6A4F', '#1B4332', '#40916C', '#52B788', '#95D5B2',
    '#74C69D', '#2D6A4F', '#4C9F70', '#478C5C', '#3F704D',
    // Various ground colors
    '#5F7161', '#4F5D2F', '#606C38', '#283618', '#3A5A40',
    '#344E41', '#6C584C', '#A98467', '#DDA15E', '#BC6C25'
  ];
  
  return (
    <div className="color-picker-overlay">
      <div className="color-picker-container">
        <div className="color-picker-header">
          <h3>Select Color</h3>
          <button className="close-button" onClick={onClose}>×</button>
        </div>
        <div className="color-presets">
          {treePresets.map((color, index) => (
            <div 
              key={index}
              className="preset-color"
              style={{ backgroundColor: color }}
              onClick={() => handleColorChange(color)}
            />
          ))}
        </div>
        <div className="color-picker-footer">
          <input 
            type="color" 
            value={activeField ? activeField.value : '#000000'}
            onChange={(e) => handleColorChange(e.target.value)}
          />
        </div>
      </div>
    </div>
  );
};

const TreeControlsRight = React.memo(({ 
  handleColorChange, 
  activeColorField, 
  setActiveColorField,
  handleRegenerateColors
}) => {
  const { state } = useContext(TreeContext);
  
  return (
    <div className="ControlColumn right-column">
      <div className="controlSection colors-section">
        <h3 className="section-title">Colors</h3>
        
        <div className="color-controls-grid">
          <ColorControl 
            label="Trunk" 
            field="trunkColor" 
            value={state.trunkColor}
            setActiveColorField={setActiveColorField}
            activeColorField={activeColorField}
          />
          
          <ColorControl 
            label="Foliage" 
            field="foliageColor" 
            value={state.foliageColor}
            setActiveColorField={setActiveColorField}
            activeColorField={activeColorField}
          />
        </div>
        
        <button 
          className="regenerate-button"
          onClick={handleRegenerateColors}
        >
          Regenerate Colors
        </button>
      </div>
      
      {/* Color picker overlay if a color field is active */}
      <ColorPicker 
        activeField={activeColorField ? { field: activeColorField, value: state[activeColorField] } : null}
        handleColorChange={handleColorChange}
        onClose={() => setActiveColorField(null)}
      />
    </div>
  );
});

export default TreeControlsRight; 